export default __webpack_public_path__ + "static/media/car.aa5382d5.svg";